import type { ReactNode } from "react";

/** The kicker (orange eyebrow), crimson headline and sub-line every screen in the mock opens with. */
export function ScreenHeader({
  kicker,
  title,
  sub,
}: {
  kicker: string;
  title: string;
  sub?: ReactNode;
}) {
  return (
    <header className="mb-[22px]">
      <div className="mb-2 text-[12px] font-bold uppercase tracking-[0.1em] text-kicker">
        {kicker}
      </div>
      <h1 className="mb-3 text-[clamp(30px,4.4vw,44px)] leading-none text-accent min-[1000px]:max-w-[24ch]">
        {title}
      </h1>
      {sub ? (
        <p className="m-0 max-w-[60ch] text-[17px] leading-[1.55] text-pretty text-text-muted">
          {sub}
        </p>
      ) : null}
    </header>
  );
}
